<template>
    <!-- 旅行  -->
    <main-page :title="title" :subtitle="subtitle" :description="description" :button-text="buttonText" :bg="bg" />
</template>

<script>
import MainPage from '@/views/components/MainPage.vue'
export default {
    name: 'journey',
    components: {
        MainPage
    },
    data() {
        return {
            bg: "/img/pay/0--49.png",
        }
    },
    computed: {
        title() {
            return this.$t('journey.title');
        },
        subtitle() {
            return this.$t('journey.subtitle');
        },
        description() {
            return this.$t('journey.description');
        },
        buttonText() {
            return this.$t('common.buttonText');
        },
    },
}
</script>